module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-72x72-2959cacc9f6a456c1241dc6fad1dadc2.png";